module.exports = __webpack_public_path__ + "img/logo2.36c0ccf7.png";